module.exports = __webpack_public_path__ + "img/27.6b65ce13.png";